export default __webpack_public_path__ + "static/media/preemp_tab_icon.63878c76.svg";